import { gql } from '@apollo/client';

export interface GetClassroomsResponse {
    testrooms: [
        {
            id: string;
            testroomName: string;
            lessonVersion: {
                lessonName: string;
            };
            endTime: string;
            class: {
                className: string;
                id: string;
                schoolYear: string;
            };
        },
    ];
    testroomsCount: number;
}

export const GET_CLASSROOMS = gql`
    query Testrooms($orderBy: [TestroomOrderByInput!]!, $skip: Int, $take: Int, $where: TestroomWhereInput!) {
        testrooms(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
            id
            testroomName
            lessonVersion {
                lessonName
            }
            endTime
            class {
                className
                id
                schoolYear
            }
        }
        testroomsCount(where: $where)
    }
`;

export interface GetClassroomResponse {
    testroom: {
        id: string;
        testroomName: string;
        lessonVersion: {
            id: string;
            slides: {
                id: string;
                sort: number;
                questionCount: number;
                data: string;
            }[];
        };
        class: {
            name: string;
            schoolYear: string;
            studentsCount: number;
            students: {
                id: string;
                familyName: string;
                givenName: string;
                studentNumber: string;
            }[];
        };
    };
}

export interface GetClassroomVariables {
    where: {
        id: string;
    };
}

export const GET_CLASSROOM = gql`
    query Testroom($where: TestroomWhereUniqueInput!) {
        testroom(where: $where) {
            id
            testroomName
            lessonVersion {
                id
                slides {
                    id
                    sort
                    questionCount
                    data
                }
            }
            class {
                name
                schoolYear
                studentsCount
                students {
                    id
                    familyName
                    givenName
                    studentNumber
                }
            }
        }
    }
`;

export interface GetHomeworkVariables {
    where: { id: string };
}

export interface GetHomeworkResponse {
    homework: {
        id: string;
        homeworkName?: string;
        lessonVersion: {
            id: string;
            slides: {
                id: string;
                sort: number;
                questionCount: number;
                data: string;
            }[];
        };
        class: {
            name: string;
            schoolYear: string;
            studentsCount: number;
            students: {
                id: string;
                familyName: string;
                givenName: string;
                studentNumber: string;
            }[];
        }[];
    };
}

export const GET_HOMEWORK = gql`
    query Homework($where: HomeworkWhereUniqueInput!) {
        homework(where: $where) {
            id
            homeworkName
            lessonVersion {
                id
                slides {
                    id
                    sort
                    questionCount
                    data
                }
            }
            class {
                name
                schoolYear
                studentsCount
                students {
                    id
                    familyName
                    givenName
                    studentNumber
                }
            }
        }
    }
`;

export interface GetHomeworksResponse {
    homeworks: [
        {
            id: string;
            homeworkName: string;
            lessonVersion: {
                lessonName: string;
            };
            endTime: string;
            class: {
                className: string;
                id: string;
                schoolYear: string;
            }[];
        },
    ];
    homeworksCount: number;
}

export const GET_HOMEWORKS = gql`
    query Homeworks($orderBy: [HomeworkOrderByInput!]!, $skip: Int, $take: Int, $where: HomeworkWhereInput!) {
        homeworks(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
            id
            homeworkName
            lessonVersion {
                lessonName
            }
            endTime
            class {
                className
                id
                schoolYear
            }
        }
        homeworksCount
    }
`;
